import React, { Component } from "react";
import "./container.css";
import logo from "../Assets/Images/logo.png";
import { Image, Accordion, Card } from "react-bootstrap";
import { NavLink, withRouter } from "react-router-dom";
import ConfirmAlert from "../component/commonComponents/ConfirmSweetAlert";
import Cookies from "universal-cookie";
import labels from "../Labels/Label";

class container extends Component {
  state = {
    confirmAlertModal: false,
    toggle: true,
    userType: localStorage.getItem("userType"),
  };
  hideShow = () => {
    this.setState({ toggle: !this.state.toggle });
  };
  render() {
    return (
      <div className="pagewrapper eieastheme toggled">
        <div id="show-sidebar" className="btn btn-sm btn-dark">
          <i className="fas fa-bars"></i>
        </div>
        <nav id="sidebar" className="sidebarwrapper">
          <div className="sidebar-content">
            <div className="sidebarheader">
              {this.state.userType == 0 ? (
                <div className="userpic">
                  <Image className="logoWidth" src={logo} alt="Logo" fluid />
                  <p>{labels.SideBarHeading}</p>
                </div>
              ) : (
                <div className="userpic">
                  <Image className="logoWidth" src={logo} alt="Logo" fluid />
                </div>
              )}
              <div className="userinfo">
                <div className="sidebarbrand">
                  <div id="close-sidebar">
                    <span className="d-sm-none">
                      <i className="fas fa-window-close closeButton"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="sidebarmenu">
              <ul id="menu">
                <li>
                  {this.state.userType == 0 ? (
                    <NavLink to="/interview">
                      <span>{labels.counsellorHeading}</span>
                    </NavLink>
                  ) : (
                    <NavLink to="/interview">
                      <span>{labels.interviewHeading}</span>
                    </NavLink>
                  )}
                </li>

                <li>
                  {this.state.userType == 1 ? (
                    <NavLink to="/profile">
                      <span>My Profile</span>
                    </NavLink>
                  ) : null}
                </li>

                <li>
                  <NavLink to="/myProfile">
                    <span>My Personal Details</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/logedinreset">
                    <span>Reset Password</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/feedback">
                    <span>Help/Feedback</span>
                  </NavLink>
                </li>

                {/* <li>
                  <NavLink to="/feedback">
                    <span>Feedback</span>
                  </NavLink>
                </li> */}

                <li onClick={() => this.setState({ confirmAlertModal: true })}>
                  <NavLink
                    to={!this.state.confirmAlertModal ? "../login" : "../login"}
                    onClick={(event) => event.preventDefault()}
                  >
                    <span>Logout </span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
          <ConfirmAlert
            msg="Are you sure you want to log out?"
            show={this.state.confirmAlertModal}
            cancelHandler={() => {
              this.setState({ confirmAlertModal: false });
            }}
            nextAction={() => {
              localStorage.setItem("userToken", "");
              new Cookies().remove("CNinterviewerId", {
                path: "/self-assessment",
                expires: "Thu, 01 Jan 1970 00:00:01 GMT",
              });
              new Cookies().remove("CNinterviewerId", {
                path: "/self-assessment/interview",
                expires: "Thu, 01 Jan 1970 00:00:01 GMT",
              });
              new Cookies().remove("CNinterviewDate", {
                path: "/self-assessment/interview",
                expires: "Thu, 01 Jan 1970 00:00:01 GMT",
              });
              new Cookies().remove("CNendTime", {
                path: "/self-assessment/interview",
                expires: "Thu, 01 Jan 1970 00:00:01 GMT",
              });
              new Cookies().remove("CNmodeofinterview", {
                path: "/self-assessment/interview",
                expires: "Thu, 01 Jan 1970 00:00:01 GMT",
              });
              new Cookies().remove("CNjobId", {
                path: "/self-assessment/interview",
                expires: "Thu, 01 Jan 1970 00:00:01 GMT",
              });
              new Cookies().remove("CNamount", {
                path: "/self-assessment/interview",
                expires: "Thu, 01 Jan 1970 00:00:01 GMT",
              });
              new Cookies().remove("CNorderId", {
                path: "/self-assessment/interview",
                expires: "Thu, 01 Jan 1970 00:00:01 GMT",
              });
              this.props.history.push("/login");
            }}
          />
        </nav>

        <main className="pagecontent">
          <div className="container-fluid">{this.props.children}</div>
        </main>
      </div>
    );
  }
}

export default withRouter(container);
